module.exports = __webpack_public_path__ + "static/img/9.0bd8328.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/9.png
// module id = 254
// module chunks = 0